module.exports = __webpack_public_path__ + "static/img/4.bab0b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/4.png
// module id = rXQ6
// module chunks = 0